import {
	colorOverflowButtonSX,
	colorOverflowInnerSX,
	colorOverflowLabelSX,
} from '@/components/blocks/ProductCardSelectColor/styles';
import { Box, ButtonBase } from '@mui/material';

interface Props {
	count: number;
}

export const ColorOverflowIndicator = ({ count }: Props) => (
	<ButtonBase aria-label={`Ver ${count} colores más`} sx={colorOverflowButtonSX}>
		<Box sx={colorOverflowInnerSX}>
			<Box component="span" sx={colorOverflowLabelSX}>{`+${count}`}</Box>
		</Box>
	</ButtonBase>
);
